import { Space, Button, Typography, Tooltip } from 'antd'
import { EditSharePointModal } from './components/EditSharePointModal'
import { useCIMSModal } from 'components/CIMSModal/hooks/useCIMSModal'
import CIMSBasicFields from 'components/CIMSBasicFields'
import { HelpMessage } from 'utils/constants'
import { useProjectSettingsContext } from '../../ProjectSettingsContext'
import { useCheckPermission } from 'hooks/useCheckPermission'
import { Permission } from 'shared'

const SharePoint: React.FC = () => {
  const [visible, toggle] = useCIMSModal()
  const { metadata, fetching, sharePointDrives } = useProjectSettingsContext()
  const { label: customDrive } =
    sharePointDrives.find(({ value }) => value === metadata?.customDriveId) ??
    {}
  const help = HelpMessage.Administration.ProjectSettings.SharePoint
  return (
    <Space direction="vertical" size="middle" style={{ maxWidth: '900px' }}>
      <EditSharePointModal visible={visible} onClose={() => toggle(null)} />
      {useCheckPermission(Permission.EditSharePointSettings) && (
        <Button type="primary" onClick={() => toggle(null)}>
          Edit SharePoint Settings
        </Button>
      )}
      <CIMSBasicFields
        loading={fetching}
        fields={[
          {
            label: 'SharePoint Site URL',
            help: HelpMessage.Administration.ProjectSettings.SharePoint.SiteURL,
            type: 'externalLink',
            linkLabel: metadata?.sharePointSiteURL,
            href: metadata?.sharePointSiteURL,
          },
          {
            label: 'SharePoint Landing Page',
            help: HelpMessage.Administration.ProjectSettings.SharePoint
              .LandingPage,
            type: 'externalLink',
            linkLabel: metadata?.sharePointSiteLandingPage,
            href: metadata?.sharePointSiteLandingPage,
          },
          {
            label: 'Complete SharePoint URL',
            help: HelpMessage.Administration.ProjectSettings.SharePoint
              .CompleteURL,
            type: 'externalLink',
            linkLabel: metadata?.sharePointURL,
            href: metadata?.sharePointURL,
          },
          {
            label: 'Custom Document Library',
            help: help.CustomDrive,
            children: metadata?.customDriveId
              ? customDrive ?? (
                  <Tooltip title={metadata?.customDriveId}>
                    Unknown Drive
                  </Tooltip>
                )
              : null,
          },
        ]}
      />
      <Typography.Paragraph style={{ fontStyle: 'italic' }}>
        {help.Instructions}
      </Typography.Paragraph>
    </Space>
  )
}

export default SharePoint
